import moment from "moment";
import AppDialog from "../../../components/Common/AppDialog";

export default function BindingResult({ open, close, resultData, windowWidth }) {
    return (
        <AppDialog
            open={open}
            close={close}
            title={'Latest COE Biding Results'}
            positiveTitle={'Close'}
            positivePress={close}
            width={'60%'}
            isMobile={windowWidth <= 768 ? true : false}
        >
            <table id="coe-binding-table" style={{ tableLayout: 'fixed' }}>
                <thead >
                    <tr className="subheader-2">
                        <th>Biding Dates</th>
                        <th>COE Price</th>
                        <th>PQP (Month)</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        resultData?.length > 0 && resultData?.slice(0, 4).map((item, index, arr) => {
                            const prev = arr[index - 1];
                            const sameMonthAsPrev = prev && prev.month === item.month;

                            if (sameMonthAsPrev) {
                                return (
                                    <tr key={index}>
                                        <td>{item.month ? moment(item.month, "YYYY-MM").format('MMM YYYY') : '-'}, Biding {item?.bidding_no} </td>
                                        <td>{`$${item.premium}`}</td>
                                    </tr>
                                );
                            }

                            let span = 1;
                            let i = index + 1;
                            while (i < arr.length && arr[i].month === item.month) {
                                span++;
                                i++;
                            }

                            return (
                                <tr key={index}>
                                    <td>{item.month ? moment(item.month, "YYYY-MM").format('MMM YYYY') : '-'}, Biding {item?.bidding_no} </td>
                                    <td>{`$${item.premium}`}</td>
                                    <td rowSpan={span > 1 ? span : undefined} style={{ background: "#F5F5F5" }}>{`$${item.pqp_current}`}</td>
                                </tr>
                            );
                        })
                    }
                </tbody>
            </table>
        </AppDialog>
    )
}